import { PageShell } from "~/components/layout/page-shell";
import { MarketNewsLoadingList } from "~/components/market-news";
import { SidebarPanel } from "~/components/sidebar-panel";
import { m } from "~/lib/i18n";
import { StocksHeroHeading } from "../ui/stocks-hero-heading";
import {
  MarketIndicatorsPending,
  StockMoverLoadingRows,
  StocksTickerStripPending,
} from "../ui/stocks-page-skeletons";

/**
 * Eager /stocks shell. Share static artwork and loading slots with the lazy
 * page without pulling its queries, charts, or trading runtime into this chunk.
 */
export function StocksPagePending() {
  return (
    <PageShell
      aria-busy="true"
      className="bg-surface-1 pb-10"
      contentClassName="pt-2"
      data-testid="stocks-page-pending"
      padY="none"
      size="wide"
    >
      <PageShell.Hero>
        <header className="relative mb-4" data-testid="stocks-image-hero">
          <div className="relative isolate overflow-hidden">
            <div className="relative flex flex-col">
              <StocksHeroHeading />
              <StocksTickerStripPending />
            </div>
          </div>
        </header>
      </PageShell.Hero>
      <PageShell.Main>
        <MarketIndicatorsPending />
        <section
          className="grid gap-4 xl:grid-cols-2"
          data-testid="stocks-movers"
        >
          {[
            m.stocks_movers_top_gainers_title(),
            m.stocks_movers_top_losers_title(),
          ].map((title) => (
            <section className="space-y-3" key={title}>
              <h2 className="text-title-sm font-medium text-foreground">
                {title}
              </h2>
              <div
                aria-hidden="true"
                className="page-surface-panel rounded-lg px-1"
              >
                <StockMoverLoadingRows count={5} />
              </div>
            </section>
          ))}
        </section>
      </PageShell.Main>
      <PageShell.Rail className="hidden lg:block" width="lg">
        <div className="p-px">
          <SidebarPanel title={m.stocks_market_news_title()}>
            <div className="min-h-[calc(30.25rem+4px)]">
              <MarketNewsLoadingList
                count={5}
                rowClassName="py-4 first:pt-0 last:pb-4 [&>div>div]:h-4"
                skeletonClassName="bg-foreground/10 motion-reduce:animate-none"
              />
            </div>
          </SidebarPanel>
        </div>
      </PageShell.Rail>
    </PageShell>
  );
}
